import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs, watch } from '@nuxtjs/composition-api';

interface Props {    
    trigger?: 'click' | 'hover' | 'focus' | 'manual';
    width?: number | string;
    offset: number | string;
    value?: boolean; 
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Compact',
  props: {
    trigger: { default: 'click' },
    width: null,
    offset: { default: 0 },
    value: { type: Boolean }
  },
  emits: ['input', 'close', 'open'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { trigger: 'click' | 'hover' | 'focus' | 'manual', width?: number | string, offset: number | string, value?: boolean };




const {
    trigger,
    offset,
    width,
    value,
} = toRefs(props);

const isOpen = ref(value.value);
watch(value, (val) => isOpen.value = val);
watch(isOpen, (val) => {
    $emit('input', val);
    if (val) {
        window.addEventListener('wheel', close, { passive: true });
        $emit('open');
    } else {
        window.removeEventListener('wheel', close);
        $emit('close');
    }
});

const close = () => isOpen.value = false;


return { __sfc: true,$emit, props, trigger, offset, width, value, isOpen, close }
}

})